import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import { ENGAGEMENT_MODELS } from "../data/content";

export default function Pricing() {
  const navigate = useNavigate();
  return (
    <section id="pricing" className="relative z-10 py-28 md:py-40 bg-[#0B132B]/40" data-testid="pricing">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">How We Engage</p>
          <h2 className="text-4xl md:text-6xl font-900 tracking-tightest max-w-3xl leading-[1] text-[#F2EFE9]">
            Built around your business.
          </h2>
          <p className="mt-6 max-w-2xl text-lg text-[#94A3B8] leading-relaxed">
            Engage us as your ongoing Fractional General Counsel, or as a private practice for discrete matters — including the funding rounds, M&amp;A and restructuring that come with scaling. One relationship, sized to the moment.
          </p>
        </Reveal>

        {/* Engagement models */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {ENGAGEMENT_MODELS.map((m, i) => (
            <Reveal key={m.title} delay={i * 0.08}>
              <div
                data-testid={`engagement-${i}`}
                className={`h-full rounded-2xl p-8 flex flex-col border transition-colors duration-300 ${
                  m.highlight ? "bg-[#D95A41] border-[#D95A41]" : "bg-[#050A14] border-white/10 hover:border-white/25"
                }`}
              >
                <span className={`text-xs font-700 tracking-[0.2em] uppercase ${m.highlight ? "text-[#F2EFE9]/80" : "text-[#D95A41]"}`}>
                  {m.tag}
                </span>
                <h3 className="mt-4 text-2xl font-700 text-[#F2EFE9] tracking-tight">{m.title}</h3>
                <p className={`text-sm ${m.highlight ? "text-[#F2EFE9]/80" : "text-[#94A3B8]"}`}>{m.subtitle}</p>
                <p className={`mt-4 text-sm leading-relaxed flex-1 ${m.highlight ? "text-[#F2EFE9]/90" : "text-[#94A3B8]"}`}>
                  {m.body}
                </p>
                <ul className="mt-6 space-y-2">
                  {m.points.map((p) => (
                    <li key={p} className={`flex items-center gap-2 text-sm ${m.highlight ? "text-[#F2EFE9]" : "text-[#94A3B8]"}`}>
                      <Check size={15} /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Closing CTA */}
        <Reveal delay={0.1}>
          <div className="mt-12 rounded-3xl border border-white/10 bg-[#050A14] px-8 py-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <p className="text-lg text-[#F2EFE9] font-500 max-w-2xl">
              Every engagement is scoped to your needs. Let&apos;s talk through the right structure for your business.
            </p>
            <button
              onClick={() => navigate("/home/book")}
              data-testid="pricing-cta-btn"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#D95A41] text-[#F2EFE9] font-700 hover:bg-[#E6735A] transition-colors whitespace-nowrap"
            >
              Book a consultation <ArrowRight size={16} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
